import './app-header.scss';
import logout from '../../assets/image/logout.svg';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function AppHeader({ title, username }) {
	const navigate = useNavigate();

	const onLogout = async () => {
		try {
			localStorage.clear();
			navigate('/');
		} catch (error) {
			toast.error('Something went wrong while logout!');
		}
	};

	return (
		<div className="app-header d-none d-md-block sticky-top">
			<div className="container-fluid px-3 px-xl-5">
				<div className="app-header__inner d-flex align-items-center justify-content-between position-relative py-2">
					<div className="d-flex align-items-center">
						<img
							onClick={() => navigate('/')}
							src="/images/updated-logo.svg"
							alt="logo"
							className="app-header__logo img-fluid"
						/>
					</div>

					<div className="app-header__title-wrapper position-absolute start-50 translate-middle-x text-center">
						<span className="app-header__title">{title}</span>
					</div>

					<div className="d-flex align-items-center gap-2 gap-xl-5">
						<span className="app-header__welcome">
							<span className="app-header__username">Welcome! {username}</span>
						</span>

						<img
							src={logout}
							alt="logout"
							height="20"
							role="button"
							onClick={onLogout}
							className="app-header__logout"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
